import moment from "./moment";

import { isValidPhoneNumber } from 'react-phone-number-input/mobile'

import { EMAIL_REGEX, NAME_REGEX, ZIP_CODE_REGEX, CITY_REGEX } from "./regexes";


const tenant = window.location.hostname.split(".")[0];
const baseURL = tenant === "app" ?
    process.env.BARESTO_PROTOCOL + '://' + process.env.BARESTO_API + '/' :
    process.env.BARESTO_PROTOCOL + '://' + tenant + '.' + process.env.BARESTO_API + '/';

export const getBaseURL = () => baseURL;

export const changeFormField = (form, name, value) => {
    const newForm = {...form};
    newForm[name].value = value;

    if (newForm[name].type === "email") {
        newForm[name].value = value.toLowerCase();
    }

    newForm[name].valid = checkFormFieldValidity(newForm[name].value, newForm[name].type);
    newForm[name].modified = true;
    return newForm;
};

export const formatPrice = value => {
    return (Math.round(value * 100) / 100).toFixed(2);
}

export const checkFormFieldValidity = (value, type) => {
    let isValid = true;
    if (type === "email") {
        isValid = EMAIL_REGEX.test(value) && isValid
    }
    if (type === "phone") {
        isValid = isValidPhoneNumber(value);
    }
    if (type === "name") {
        isValid = NAME_REGEX.test(value) && isValid;
    }
    if (type === "adults") {
        isValid = value > 0 && isValid
    }
    if (type === "children") {
        isValid = true
    }
    if (type === "string") {
        isValid = value.length > 0
    }
    if (type === "street") {
        isValid = value.length > 0 && value.length <= 50
    }
    if (type === "street_number") {
        isValid = value.length > 0 && value.length <= 6
    }
    if (type === "zip_code") {
        isValid = ZIP_CODE_REGEX.test(value)
    }
    if (type === "city") {
        isValid = CITY_REGEX.test(value)
    }
    if (type === "gdpr") {
        isValid = value
    }

    return isValid;
};

export const shouldFieldBeRed = (field) => {
    return !checkFormFieldValidity(field.value, field.type) && field.modified
};

export const isFormValid = (form) => {
    const fields = Object.keys(form);
    for (const field of fields) {
        if (!checkFormFieldValidity(form[field].value, form[field].type)) {
            return false;
        }
    }
    return true;
};

export const getMinCakeDateTime = (cake_before_duration) => {
    const before_duration = cake_before_duration.split(" ");
    const bdLength = before_duration.length;
    const beforeDays = bdLength > 1 ? parseInt(before_duration[0]) : 0;
    const beforeHours = bdLength > 1 ?
        parseInt(before_duration[1].slice(0, 2)) :
        parseInt(before_duration[0].slice(0, 2));

    return moment().add(beforeDays, "days").add(beforeHours, "hours");
};

export const generateRandomId = () => {
    return Math.random().toString(36).substr(2, 9);
}

export const getVirtualShifts = (shifts) => {
    let virtualShifts = [];

    shifts.forEach(shift => {
        if (shift.split_shift) {
            let current_start_hour = moment(shift.from_hour, "HH:mm:ss");
            const start_hour = moment(shift.from_hour, "HH:mm:ss");
            const end_hour = moment(shift.to_hour, "HH:mm:ss");
            const interval = shift.interval;

            while (current_start_hour <= end_hour) {
                virtualShifts = virtualShifts.concat(
                    [
                        {
                            ...shift,
                            id: generateRandomId(),
                            from_hour: moment(current_start_hour).format("HH:mm:ss"),
                            to_hour: moment(current_start_hour).format("HH:mm:ss"),
                            shift_start: start_hour,
                        }
                    ]
                );
                current_start_hour = moment(current_start_hour).add(interval, "minutes");
            }
        }
        else {
            virtualShifts = virtualShifts.concat([{...shift, id: generateRandomId(), shift_start: moment(shift.from_hour, "HH:mm:ss")}]);
        }
    })

    return virtualShifts;
}

export function isMobile() {
    const regex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return regex.test(window.navigator.userAgent);
}

/**
 * Returns an action object for Redux.
 * @param {string} type - action type 
 * @param {{[string]: any} | null} meta - object containing action data.
 * @returns {{type: string, [string]: any}}
 */
export const sendAction = (type, meta = null) => (meta ? {type, ...meta} : {type});


export const getReservationKey = (last_name, token) => `${last_name}_${token}`.replace(' ', '');

/**
 * Returns `true` if a value is empty (value of length 0 for string and array, 0 keys for objects or null/undefined value).
 * @param {any} value 
 * @returns 
 */
export const isEmpty = (value) => {
    const type = typeof value;
    if(!['string', 'object', 'undefined'].includes(type)) {
        return false;
    }
    return (value === null || value === undefined || value.length === 0 || Object.keys(value).length === 0);
}


// WEBPACK FOOTER //
// ./src/helpers.js